import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    initialize() {}

    connect() {
	this.setup()
    }

    setup() {
	var sourceElement = document.querySelector(this.element.dataset.sourceSelector)
	if(sourceElement) {
	    var headings = sourceElement.querySelectorAll("h2, h3")
	    var tocElement = this.element.querySelector('ol, ul')
	    var lastH2Li = null

	    headings.forEach(heading => {
		var text = heading.innerText
		var id = text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-")

		// set heading
		heading.id = id

		// set anchor link
		var anchor = document.createElement("a")
		anchor.href = "#" + id
		anchor.className = "navigator-anchor"
		anchor.ariaLabel = "Link to this section"
		anchor.innerHTML = "🔗"
		heading.append(anchor)

		// copy link to clipboard when clicked on anchor
		anchor.addEventListener("click", e => {
		    e.preventDefault()
		    var url = window.location.origin + window.location.pathname + anchor.getAttribute("href")
		    if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(url)
		    }
		})

		// set navigator item
		var li = document.createElement("li")
		var a = document.createElement("a")
		a.href = "#" + heading.id
		a.textContent = text
		li.appendChild(a)

		if (heading.tagName === "H2") {
		    // nested level 1
		    tocElement.appendChild(li)
		    lastH2Li = li
		} else if (heading.tagName === "H3") {
		    // nested level 2
		    if (lastH2Li) {
			let ul = lastH2Li.querySelector("ul")
			if (!ul) {
			    ul = document.createElement("ul")
			    lastH2Li.appendChild(ul)
			}
			ul.appendChild(li)
		    } else {
			tocElement.appendChild(li)
		    }
		}

		a.addEventListener("click", (e) => {
		    e.preventDefault()
		    document.querySelector(a.getAttribute('href')).scrollIntoView({ behavior: "smooth" })
		})
	    })
	}
    }

    onScroll() {
	var sourceElement = document.querySelector(this.element.dataset.sourceSelector)
	if(sourceElement) {
	    var headings = sourceElement.querySelectorAll("h2, h3")
	    var tocElementLinks = this.element.querySelectorAll('ol a, ul a')

	    let current = ""
	    headings.forEach(heading => {
		const top = heading.offsetTop - 120

		if (scrollY >= top) {
		    current = heading.getAttribute("id")
		}
	    })

	    tocElementLinks.forEach(link => {
		link.classList.remove("active")
		if(link.getAttribute("href") === "#" + current) {
		    link.classList.add("active")
		}
	    })
	}
    }
}
